import {
  GET_SUMMARY_SECTION_INFORMATION,
  GET_SUMMARY_SECTION_INFORMATION_ERROR,
  GET_SUMMARY_SECTION_INFORMATION_SUCCESS,
  GET_OPEN_DATA_INFORMATION,
  GET_OPEN_DATA_INFORMATION_ERROR,
  GET_OPEN_DATA_INFORMATION_SUCCESS
} from './SummarySection.actions'

const summarySectionState = {
  awardedAgreements: [],
  contractualBehavior: {
    hasNoRate: false,
    rate: 0,
    max: 5,
    percentage: ''
  },
  error: undefined,
  loading: true,
  openDataLoading: true,
  openDataError: undefined,
  salesLastMonths: {
    amount: 0,
    period: ''
  }
}

/**
 * The Summary Section reducer.
 */
const summarySectionReducer = (state = summarySectionState, { payload, type }) => {
  switch (type) {
    case GET_SUMMARY_SECTION_INFORMATION: {
      return { ...state, loading: true }
    }
    case GET_SUMMARY_SECTION_INFORMATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        awardedAgreements: payload.awardedAgreements,
        contractualBehavior: {
          ...payload.contractualBehavior
        }
      }
    }
    case GET_SUMMARY_SECTION_INFORMATION_ERROR: {
      return {
        ...state,
        loading: false,
        error: payload.error
      }
    }
    case GET_OPEN_DATA_INFORMATION: {
      return {
        ...state,
        openDataLoading: true,
        openDataError: undefined
      }
    }
    case GET_OPEN_DATA_INFORMATION_SUCCESS: {
      return {
        ...state,
        openDataLoading: false,
        openDataError: undefined,
        salesLastMonths: {
          ...payload.salesLastMonths
        }
      }
    }
    case GET_OPEN_DATA_INFORMATION_ERROR: {
      return {
        ...state,
        openDataLoading: false,
        openDataError: payload.error
      }
    }
    default: {
      return state
    }
  }
}

export default summarySectionReducer
